import { Component } from '@angular/core';

@Component({
   standalone: true,
  selector: 'app-invalidated-request',
  templateUrl: './invalidated-request.component.html',
  styleUrl: './invalidated-request.component.scss'
})
export class InvalidatedRequestComponent {

}
